import "@perxis-auto/shared/lib";
import { formatVehicleDescription } from "../../../shared/lib/format/vehicle/formatVehicleDescription.js";
import "@perxis-auto/shared";
import { formatVehicleTitle } from "../../../shared/lib/format/vehicle/formatVehicleTitle.js";
import { formatVehicleStatus } from "../../../shared/lib/format/vehicle/formatVehicleStatus.js";
import "../../../shared/lib/logger/index.js";
const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onBackClick: {
      to: "/"
    }
  },
  showTitle: true,
  formatVehicleTitle,
  formatVehicleDescription,
  formatVehicleStatus
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
